<template>
  <div id="example1">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true" />
    <div class="centered whiteDivContainer pb-4">

          <div class="mt-5">
            <img
                class="imgSize"
                :src="require('../../assets/Logo dentalia-blue.png')"
            />
            <b-alert class="mt-5" v-if="!primeraPantalla && !segundaPantalla && !terceraPantalla && !cuartaPantalla && listaPaciente !== null" show variant="warning">No hay Pacientes</b-alert>
            <div v-if="primeraPantalla">
              <p class="m-2"><strong>Seleccione a los pacientes que no renovarán el plan</strong></p>
            <b-row class="ml-2 mr-2 mr-lg-0">
              <b-col cols="12" sm="12" md="12" lg="7" class="mt-3 mt-lg-0 ml-lg-5" order="2" order-sm="2" order-md="2" order-lg="1">
                <div class="contenedorTablaSinColor">
                  <b-row>
                    <b-col cols="6" sm="6" md="6"  class="m-2">
                      <p class="card-titulo">Pacientes del {{planSeleccionado.nombrePlan}}</p>
                    </b-col>
                    <b-col cols="6" sm="5" md="3" class="mt-2">
                      <div style="background-color: #A7CFE6; border-radius: 20px;width: 9vh; color: #004A98; font-weight: bolder">
                        <p >${{planSeleccionado.precioFinalPlan}}</p>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="text-left ml-4" cols="5" sm="3">
                      <p>Titular del plan:</p>
                    </b-col>
                    <b-col class="text-left" cols="5" sm="4">
                      <strong>{{planSeleccionado.titularPlan}}</strong>
                    </b-col>
                  </b-row>
                  <b-table-simple sticky-header responsive>
                    <b-thead class="columnasTablaSinColor">
                      <b-tr>
                        <b-th class="border-top-0" v-for="(fieldsTablas, index) in titulos" :key="index">
                          {{ fieldsTablas.label }}
                        </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(paciente, index) in listaPaciente" :key="index">
                        <b-td>{{ index +1  }}</b-td>
                        <b-td>{{ paciente.nombrePaciente }}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  <b-alert v-if="listaPaciente.length === 0" show variant="warning">No hay Pacientes</b-alert>
                </div>
              </b-col>
              <b-col cols="12" sm="12" md="12" lg="4" class="ml-lg-4" order="1" order-sm="1" order-md="1" order-lg="2">
                <div class="contenedorTablaSinColor">
                  <p class="card-titulo mt-2">Planes</p>
                  <b-table-simple sticky-header responsive hover>
                    <!-- pao -->
                    <b-thead class="columnasTablaSinColor">
                    <b-tr>
                      <b-th class="border-top-0" v-for="(fieldsTablas, index) in titulosCancelar" :key="index">
                        {{ fieldsTablas.label }}
                      </b-th>
                    </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(plan, index) in listaPlanes" :key="index">
                        <b-td :style="indexSeleccionado === index ? 'background-color:rgb(230 245 255)' : ''"><b-form-checkbox :key="index" v-model="plan.cancelarPlan"></b-form-checkbox></b-td>
                        <b-td :style="indexSeleccionado === index ? 'background-color:rgb(230 245 255)' : ''" @click="onRowSelected(index)">{{ plan.nombrePlan }}</b-td>
                        <b-td :style="indexSeleccionado === index ? 'background-color:rgb(230 245 255)' : ''" @click="onRowSelected(index)">{{ plan.tipoPlan }}</b-td>
                        <b-td :style="indexSeleccionado === index ? 'background-color:rgb(230 245 255)' : ''" @click="onRowSelected(index)">{{ plan.certificadosPacientes.length }}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  <b-button @click="abrirModal()" v-if="listaPlanes.length > 0" pill variant="primary" size="sm" class="m-2" :disabled="!habilitarBtnCancelar"
                  >Cancelar renovación</b-button>
                  <b-alert v-if="listaPlanes.length === 0" show variant="warning">No hay Planes</b-alert>
                </div>
              </b-col>
            </b-row>
            </div>
            <div v-if="segundaPantalla" >
               <h3 class="mt-5" style="color: #168AAD">¡Listo! <br>
                 Se ha cancelado la renovación de los pacientes <br>
                   seleccionados</h3>
              <h5 class="mt-5">
                Tu opinión es muy importante para nosotros, por favor cuéntanos porque no has decidido <br>renovar
              </h5>
              <b-form-group class="mt-3 mb-5 ml-2 mr-2">
                <b-form-select
                    id="motivo" name="motivo" placeholder="Motivo Cancelación"
                    :options="motivosCancelacionStripe"
                    value-field="idMotivoCancelacion"
                    text-field="motivoCancelacion"
                    style="max-width: 500px"
                    v-model="motivoSeleccionado"
                >
                </b-form-select>
              </b-form-group>
              <div v-if="motivoSeleccionado === 5" class="centrar-elementos">
              <b-form-textarea
                  id="textarea"
                  class="ml-2 mr-2"
                  v-model="comentarios"
                  placeholder="Escriba el motivo por el cual canceló"
                  rows="3"
                  max-rows="6"
                  style="max-width: 1000px"
              ></b-form-textarea>
              </div>
              <b-button @click="enviarRespuesta()" pill variant="primary"  class="m-2" :disabled="!habilitarBtnEnviar"
              >Enviar respuesta</b-button>
            </div>
            <div v-if="terceraPantalla" class="mt-5">
              <h3 class="mt-5" style="color: #168AAD">¡Muchas gracias por tus comentarios!</h3>
              <h5 class="mt-5">
                Recuerda que puedes volver a contratar tu plan dental cuando gustes. Esperamos verte de nuevo.
              </h5>
            </div>
            <div v-if="cuartaPantalla" class="mt-5 p-4">
              <h3 class="mt-5" style="color: #168AAD">¡Lo sentimos!</h3>
              <h5 class="mt-5">
                Este link ha expirado porque ya se hizo la renovación. Si deseas cancelar, por favor revisa nuestra política de cancelaciones en el correo de confirmación. 
              </h5>
            </div>
          </div>
        </div>
    <div class=" diente">
      <img  alt="diente" :src="require('../../assets/diente_trans.png')"/>
    </div>
    <div class=" diente-tras">
      <img  alt="diente" :src="require('../../assets/diente_completo_trans.png')"/>
    </div>
  </div>
</template>
<script>
import { LoginService } from "@/apiServices/login/LoginService";

export default {
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    ticketToken: null,
    options: [
      {value: null, text: 'Si Acepto'},
      {value: 'a', text: 'No Acepto'}
    ],
    informacionTicket: {
      nombreCompleto: null,
      nombrePlan: null,
      ultimosDigitos: null,
      montoPagar: null,
      fechaRenovacion: null
    },
    headers: undefined,
    loginService: new LoginService(),
    blnMostrarBotones: false,
    loaderInformacionTicket: true,
    loaderAceptar: false,
    loaderRechazar: false,
    disabledBotones: false,
    listaPaciente: [],
    listaPlanes: [],
    titulos: [
      { key: "noPaciente", label: "No. paciente" },
      { key: "nombrePaciente", label: "Nombre de Paciente" }
    ],
    titulosCancelar: [
      { key: "cancelarPlan", label: "Cancelar Plan" },
      { key: "nombrePlan", label: "Nombre" },
      { key: "tipoPlan", label: "Tipo Plan" },
      { key: "numeroPaciente", label: "Número Pacientes" }
    ],
    indexSeleccionado:0,
    planSeleccionado: null,
    primeraPantalla:false,
    segundaPantalla:false,
    terceraPantalla:false,
    cuartaPantalla:false,
    motivosCancelacionStripe:[],
    motivoSeleccionado: null,
    comentarios: null,
    loading: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    let parametros = this.$route.params.ticketToken.split('/*')
    this.ticketToken  = Number(this.$global.desencriptar(parametros[0]).replace(/"/g, ''));
    this.generarToken();
    
  },
  methods: {
    async verificarRenovacion(){
      await this.$http
        .post(this.$api + "portalV2/verificarRenovacion", this.ticketToken,
        { 'headers': { 'Authorization': this.headers}})
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.primeraPantalla = true;
              this.segundaPantalla = false;
              this.terceraPantalla = false;
              this.cuartaPantalla = false;
            }else{
              this.primeraPantalla = false;
              this.segundaPantalla = false;
              this.terceraPantalla = false;
              this.cuartaPantalla = true;
            }
        }).catch((error) => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Ocurrió un error al procesar su solicitud, por favor inténtelo más tarde.",
          });
        }).finally(() => {
          this.loading = false;
        });
    },

    async generarToken() {
      await this.loginService
          .login(
              process.env.VUE_APP_ACCESS_FACTURACOMERCIAL_USER,
              process.env.VUE_APP_ACCESS_FACTURACOMERCIAL_DATO
          )
          .then(async (response) => {
            this.headers = response.Authentication;
            await this.verificarRenovacion();
            await this.traerInformacionTicket();
            this.listaPaciente = this.listaPlanes[this.indexSeleccionado].certificadosPacientes;
            this.planSeleccionado = this.listaPlanes[this.indexSeleccionado];
            this.traerMotivosCancelacio();
          });
    },
    async traerInformacionTicket() {
      await this.$http
          .post(
              this.$api +
              "stripe/certificado/obtenerIdTicketPago",this.ticketToken,
              { 'headers': { 'Authorization': this.headers}}

          ).then((response) => {
             this.blnMostrarBotones = true;
             this.listaPlanes = response.data.data.planesInformacion;
          })
          .catch((error) => {
            this.$swal({
              icon: "error",
              text: "Ocurrio Un error"
            });
            this.mensaje = error.response.data.message;
          }).finally(()=>{
            this.loaderInformacionTicket = false;
      })
    },
    traerMotivosCancelacio() {
      let url = this.$api + "catalogos/obtenerMotivoCancelacion";
      this.$http
          .get(url,{ 'headers': { 'Authorization': this.headers}})
          .then((response) => {
            if (response.data.data) {
              this.motivosCancelacionStripe = response.data.data;
            }
          })
          .catch((err) => {
            this.errorTraerDatos(err);
          });
    },
    onRowSelected(index){
      this.indexSeleccionado = index;
      this.planSeleccionado = this.listaPlanes[index];
      this.listaPaciente = this.listaPlanes[index].certificadosPacientes;
    },
    chechkbokPlan(index){
      this.listaPlanes[index].cancelarPlan = !this.listaPlanes[index].cancelarPlan;
    },
    abrirModal(){
      let tituloAlerta = '<span class="mt-4" style="font-weight:600; font-size: 20px; color: var(--color-gris)">¿Estás seguro de cancelar?</span></br></br>'
      let parrafo = '<span >Los pacientes de los planes seleccionados ya no contarán con</br>' +
          'los beneficios de cada plan al terminar la vigencia actual.</span>'
      this.$swal.fire({
        width: '750px',
        icon: 'warning',
        html: tituloAlerta + parrafo,
        showCloseButton: false,
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        confirmButtonColor: '#eeba6d',
        cancelButtonText: 'No, cancelar',
        cancelButtonColor: '#595959',
        customClass: {
          confirmButton: 'mr-1 mr-sm-5 rounded-pill',
          cancelButton: 'ml-1 ml-sm-5 rounded-pill'
        },
      }).then((result) => {
        this.loading = true;
        if (result.isConfirmed) {
          const infoCancelacion = {
            idTicket: this.ticketToken,
            planesInformacion: this.listaPlanes
          }
          this.$http
        .post(this.$api + "portalV2/baja/suscripcion", infoCancelacion,{ 'headers': { 'Authorization': this.headers}})
        .then((respuesta) => {
          if (respuesta.status == 200) {
            this.primeraPantalla = false;
            this.segundaPantalla = true;
            }
        }).catch((error) => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Ocurrió un error al procesar su solicitud, por favor inténtelo más tarde.",
          });
        }).finally(() => {
          this.loading = false;
        });
        }else{
          this.loading = false;
        }
      })
    },
    enviarRespuesta(){
      const infoCancelacion = {
        idMotivo: this.motivoSeleccionado,
        comentarios: this.comentarios,
        idTicket: this.ticketToken
      }

      this.$http
        .post(this.$api + "portalV2/baja/motivos", infoCancelacion,{ 'headers': { 'Authorization': this.headers}})
        .then((respuesta) => {
          if (respuesta.status == 200) {
            this.primeraPantalla = false;
            this.segundaPantalla = false;
            this.terceraPantalla = true;
            }
        }).catch((error) => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Ocurrió un error al procesar su solicitud, por favor inténtelo más tarde.",
          });
        }).finally(() => {
          this.loading = false;
        });

    }
  },
  computed: {
    habilitarBtnCancelar() {
      return this.listaPlanes.some(ls => ls.cancelarPlan === true)
    },
    habilitarBtnEnviar() {
      if (this.motivoSeleccionado !== null && this.motivoSeleccionado !== 5) {
        return true;
      } else if (this.motivoSeleccionado === 5 && this.comentarios !== null && this.comentarios !== ''){
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>
<style scoped>
  .b-table-sticky-header {
  height: 45vh; 
  }

.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: scroll;
  overflow-x: hidden;
}
.whiteDivContainer {
  height: 93vh ;
  border-radius: 20px;
  width: 90%;
  background-color: white;
  -webkit-box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}
#example1 {
background-color: #e6f5ff;
height: 100vh;
width: 100%;
}

.imgSize {
width: 25vh;
}


.pacientes-plan{
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  height: 50vh;
  width: 100%;
  border-radius: 9px;
}
.card-titulo{
  font-weight: bolder;
  color: #4C9CCD;
  text-align: left;
  margin-left: 1vw;
  font-size: medium;
}

p{
  font-size: small;
}

.diente{
  top: 72%;
  width: 9% !important;
  position: absolute;
  z-index: 1;
}

.diente-tras{
  top: 45%;
  position: absolute;
  z-index: 1;
  right: 3vw;
}
.tabla-planes{
  height: 37vh !important;
}

.btn-primary{
background-color: #3F9BD3;
}
.contenedorTablaSinColor {
  padding: 8px;
  height: 62vh;
  -webkit-box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px !important;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px !important;
  border-style: hidden !important;
}
table.b-table > thead > tr > .table-b-table-default {
  color: #5d5d5d !important;
  background-color: #ffffff !important;
}

@media (max-width: 900px) {
  .whiteDivContainer {
    height: 100vh !important;
  }
}
@media only screen and (max-width: 900px) {
  .tabla-planes{
    height: 60vh !important;
  }
  .pacientes-plan{
    height: 78vh !important;
  }
}

</style>
